
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---

export const addRegistration = createAsyncThunk(
    'exeregistration/addRegistration',
    async ({ values, selectedClient, loginData }, { rejectWithValue }) => {
        try {
            const AdminID = loginData?.data?._id;


            const StartDate = new Date(values.RegisterStartDate);
            const EndDate = new Date(values.RegisterEndDate);
            const now = new Date();

            StartDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
            EndDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());

            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                return `${year}-${month}-${day} ${hours}:${minutes}`;
            };

            const payload = {
                Connection: values.Connection,
                PhysicalAddress:
                    selectedClient?.PhysicalAddress || values.PhysicalAddress || "",
                StaticIP: selectedClient?.StaticIP || values.StaticIP || "",
                RegisterStartDate: formatDate(StartDate),
                RegisterEndDate: formatDate(EndDate),
                ProjectID: values.ProjectIDs,
                ProjectData: selectedClient?.Project || values.Project || [],
            };

            const response = await axios.post(
                `${BaseUrl}/registration_add/${AdminID}/${selectedClient._id}`,
                payload
            );

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// --- Fetch Exe Registration List ---
export const fetchRegistration = createAsyncThunk(
    'exeregistration/fetchRegistration',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/registration_view`);
            return response.data.data;

        } catch (error) {
            return rejectWithValue("Failed to fetch registration. Please try again later.");
        }
    }
);

// --- Update Registration ---
export const UpdateRegistration = createAsyncThunk(
    'exeregistration/updateRegistration',
    async ({ selectedRegistration, payload }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/registration_update/${selectedRegistration._id}`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Failed to update registration"
            );
        }
    }
);

// --- Delete Registration ---
export const DeleteRegistration = createAsyncThunk(
    'exeregistration/deleteRegistration',
    async ({ id, token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/registration_delete/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            return { id, message: response.data.message };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to delete registration."
            );
        }
    }
);

// --- Redux Slice ---
const ExeRegistrationSlice = createSlice({
    name: 'exeregistration',
    initialState: {

        // Add Registration State
        AddRegData: null,
        addRegLoading: false,
        addRegError: null,

        RegistrationList: [],
        RegistrationLoading: false,
        RegistrationError: null,


        // Update Registration
        updateRegSuccess: false,
        updateRegLoading: false,
        updateRegError: null,

        deleteRegLoading: false,
        deleteRegError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ---- Add Registration ----
            .addCase(addRegistration.pending, (state) => {
                state.addRegLoading = true;
                state.addRegError = null;
            })
            .addCase(addRegistration.fulfilled, (state, action) => {
                state.addRegLoading = false;
                state.AddRegData = action.payload;
            })
            .addCase(addRegistration.rejected, (state, action) => {
                state.addRegLoading = false;
                state.addRegError = action.payload || "Failed to add registration";
            })

            // Fetch Registration List
            .addCase(fetchRegistration.pending, (state) => {
                state.RegistrationLoading = true;
                state.RegistrationError = null;
            })
            .addCase(fetchRegistration.fulfilled, (state, action) => {
                state.RegistrationLoading = false;
                state.RegistrationList = action.payload;
            })
            .addCase(fetchRegistration.rejected, (state, action) => {
                state.RegistrationLoading = false;
                state.RegistrationError = action.payload;
            })

            // --- Update Registration Cases ---
            .addCase(UpdateRegistration.pending, (state) => {
                state.updateRegLoading = true;
                state.updateRegError = null;
            })
            .addCase(UpdateRegistration.fulfilled, (state, action) => {
                state.updateRegLoading = false;
                const updated = action.payload;

                // Optional: Update the list locally
                const index = state.RegistrationList.findIndex((r) => r._id === updated._id);
                if (index !== -1) {
                    state.RegistrationList[index] = updated;
                }
            })
            .addCase(UpdateRegistration.rejected, (state, action) => {
                state.updateRegLoading = false;
                state.updateRegError = action.payload;
            })

            // --- Delete Registration Cases ---
            .addCase(DeleteRegistration.pending, (state) => {
                state.deleteRegLoading = true;
                state.deleteRegError = null;
            })
            .addCase(DeleteRegistration.fulfilled, (state, action) => {
                state.deleteRegLoading = false;
                const deletedId = action.payload.id;
                state.RegistrationList = state.RegistrationList.filter(reg => reg._id !== deletedId);
            })
            .addCase(DeleteRegistration.rejected, (state, action) => {
                state.deleteRegLoading = false;
                state.deleteRegError = action.payload;
            })
    }
});

// Export the reducer
export default ExeRegistrationSlice.reducer;